import { fetch, Method } from 'core/api/fetch';

const ReportRoutes = {
    getHostReports: (params) => `/api/v1.1.1/host/report/host?${params}`,
};

export const ReportService = {
    getHostReports: async ({ startDate, endDate, timezone, contractIds, experienceIds, paymentStatus, originIds, currency }) => {
        try {
            const params = new URLSearchParams();

            if (startDate) {
                params.append('startDate', String(startDate?.toISO()));
            }
            if (endDate) {
                params.append('endDate', String(endDate?.toISO()));
            }
            if (timezone) {
                params.append('timezone', String(timezone));
            }
            if (Array.isArray(originIds) && originIds?.length > 0) {
                originIds.forEach(({ id }) => params.append('originIds', id));
            }
            if (Array.isArray(contractIds) && contractIds?.length > 0) {
                contractIds.forEach((id) => params.append('contract', id));
            }
            if (Array.isArray(experienceIds) && experienceIds?.length > 0) {
                experienceIds.forEach((id) => params.append('experience', id));
            }
            if (Array.isArray(paymentStatus) && paymentStatus?.length > 0) {
                paymentStatus.forEach(({ id }) => params.append('status', id));
            }
            if (currency) {
                params.append('currency', currency);
            }

            const { data } = await fetch(ReportRoutes.getHostReports(params.toString()), {
                method: Method.GET,
                authenticated: true,
            });

            return !data ? {} : data;
        } catch (error) {
            throw error;
        }
    },
};
